import axios from '@/jslib/axios'

export const getRenewalList = (params, other) => {
  return axios({
    method: 'get',
    url: '/admin/renewal/list',
    params,
    ...other
  })
}

export const renewOrderSave = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/order/save',
    data
  })
}

export const renewReplyCase = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/reply/case',
    params
  })
}

export const getRenewReferUnderwriting = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/plan/optional',
    params
  })
}

export const getRenewalPlanBenefit = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/plan/benefit',
    data
  })
}

export const getRenewPremiumData = params => {
  return axios({
    method: 'get',
    url: '/admin/renewal/premium/data',
    params
  })
}

export const getRenewMain = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/main',
    data
  })
}

export const renewReply = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reply',
    data
  })
}

export const renewQuoteDel = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/quote/del',
    data
  })
}

export const renewBuyQuoteList = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/buy/quote',
    data
  })
}

export const renewReplySend = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reply/send',
    data
  })
}

export const renewBuyPolicy = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/buy/policy',
    data
  })
}

export const renewRemind = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/remind/cancel',
    data
  })
}

export const getRenewPersonalCoverage = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/accident/cvr_opt',
    data
  })
}

export const getRenewPersonalBenifit = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/accident/benefit_opt',
    data
  })
}

export const getRenewHomeExcess = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/home/excess',
    data
  })
}
export const createRenewalTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/ticket/create',
    data
  })
}
export const saveRenewalTicketOrder = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/ticket/order/save',
    data
  })
}
export const createRenewalReminderRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reminder/remark/create',
    data
  })
}
export const createRenewalReminder = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/reminder/create',
    data
  })
}
export const delRenewalReminder = data => {
  return axios({
    method: 'delete',
    url: '/admin/renewal/reminder/del',
    data
  })
}
export const setRenewalTicketStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/ticket/status/set',
    data
  })
}
export const setRenewalMailNotice = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/mail/notice/set',
    data
  })
}
export const voidRenewalTicket = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/ticket/void',
    data
  })
}
export const getRenewalMailList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/renewal/mail/ticket/list',
    params,
    ...other
  })
}
export const setRenewalMailStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/renewal/mail/status/set',
    data
  })
}
